import { Directive, TemplateRef, inject } from '@angular/core';

/**
 * Marks a template as the modal's custom footer, replacing the shell's default
 * config-driven Cancel/primary footer. For modals that need extra buttons or
 * step navigation (e.g. a wizard's Back/Next):
 *
 *   <app-modal ...>
 *     <ng-template modalFooter>
 *       <button (click)="back()">Back</button>
 *       <button (click)="next()">Next</button>
 *     </ng-template>
 *   </app-modal>
 */
@Directive({
  selector: 'ng-template[modalFooter]',
})
export class ModalFooterDirective {
  readonly template = inject<TemplateRef<unknown>>(TemplateRef);
}
